
import { TextKeyMap } from '@/utils/xlsx'
import { ExtractPropTypes, PropType } from 'vue'
export type DateFormat = 'YYYY-MM-DD HH:mm' |
  'YYYY-MM-DD' | 'YYYY-MM' | 'NOW'
type ValidateType = 'mobilePhone' | 'idCard' | 'bankAccount' | 'realName' | 'not'
export type ValidateKeyAndType = {
  [key: string]: {
    required: boolean, // 校验是否必填
    type: ValidateType, // 校验类型 not 是不校验
    requiredAssociationKey?: string, // 校验关联的另一个字段key
    associationValidateString?: string // 校验的字段填什么会影响到另一个字段

  }
}
type TextKeyMapArray = {
  // 需要去 % 的key
  needRemovePercentKey?: string[],
  // 菜单映射
  textKeyMap: TextKeyMap,
  // 是否过滤数据
  isFilter?: boolean,
  // 过滤数据依赖的key和指定的字符 key===String 过滤掉整条数据
  filterDependedKeyAndString?: FilterDependedKeyAndString
}
export type FilterDependedKeyAndString = {
  key: string,
  dependedString: string
}
export const realnamecheckExcelImportProps = {


  // 是否过滤数据
  isFilter: {
    type: Boolean,
    default: false
  },
  // 过滤数据依赖的key和指定的字符,  key===String 过滤掉整条数据
  filterDependedKeyAndString: {
    type: Object as PropType<FilterDependedKeyAndString>,
    default: {}
  },
  // 多sheet导入时，不需要解析的sheet
  notResolvedSheetIndex: {
    type: Array<number>,
    default: []
  },
  // 多sheet导入时，用来判断是否导错模板
  sheetNames: {
    type: Array<string>,
    default: [],
  },
  // 菜单映射
  textKeyMap: {
    type: Object as PropType<any>,
    default: {}
  },
  // // 最大excel导入数据条数
  maxImportNum: {
    type: Number,
    default: 500
  },
  // 模板下载链接
  downLoadUrl: {
    type: String,
    default: ''
  },
  // 下载模板表名
  excelName: {
    type: String,
    default: '默认表格'
  },
  // 想要转换的格式
  format: {
    type: String as PropType<DateFormat>,
    default: 'YYYY-MM-DD'
  },
  // 需要转换日期格式的key
  needFormatDataKey: {
    type: Array<string>,
    default: []
  },
  // 提示文字
  warningTexts: {
    type: Array<string>,
    default: [
      '1、仅支持excel文件（格式为.xlsx和.xls），数据必须放在第一个sheet；',
      '2、上传表格支持范围: 不超过500行，且大小不超过5M的文件；'
    ]
  },
  // 需要去 % 的key（会转成小数）
  needRemovePercentKey: {
    type: Array<string>,
    default: []
  },
  // 实名认证两要素识需要的信息
  realNameCheckParams: {
    type: Object as PropType<{projectId:number, contractId:number}>,
    require: true
  },

  /** 表格导入验证完成的回调 */
  onComplete: {
    type: Function,
    default: () => {
      console.log('执行验证完成回调')
    }
  }

}
export type RealnamecheckExcelImportProps = Partial<ExtractPropTypes<typeof realnamecheckExcelImportProps>>